import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { industries } from "@/data/industries";

export const IndustriesGrid = () => {
  return (
    <section
      data-testid="industries-section"
      id="industries"
      className="relative py-24 md:py-32 border-t border-white/10"
    >
      <div className="absolute inset-0 grid-bg opacity-20 pointer-events-none" />
      <div className="container-x relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="font-mono-label text-xs text-[#00F0FF] mb-4">
              / 02 — Industries
            </div>
            <h2
              data-testid="industries-heading"
              className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight max-w-3xl"
            >
              Deep in{" "}
              <span className="text-[#00F0FF]">four verticals</span>. Generalist
              enough to see across them.
            </h2>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            Every industry has its own physics. Our teams pair deep domain
            partners with senior AI engineers — so you get advice that
            respects both.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {industries.map((ind, i) => (
            <Link
              key={ind.slug}
              to={`/industries/${ind.slug}`}
              data-testid={`industry-card-${ind.slug}`}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0F0F13] transition-transform duration-300 hover:-translate-y-1 hover:border-[#00F0FF]/40"
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={ind.image}
                  alt={ind.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F13] via-[#0F0F13]/40 to-transparent" />
                <div className="absolute top-4 left-4 font-mono-label text-[10px] px-2.5 py-1 rounded-full border border-white/20 bg-black/50 text-[#00F0FF]">
                  0{i + 1}
                </div>
              </div>
              <div className="p-6 md:p-8">
                <h3 className="font-display text-2xl md:text-3xl text-white tracking-tight">
                  {ind.name}
                </h3>
                <p className="mt-2 text-[#00F0FF] text-sm">{ind.tagline}</p>
                <p className="mt-4 text-white/60 leading-relaxed">
                  {ind.summary}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm text-white group-hover:text-[#00F0FF] transition-colors">
                  Explore use cases & user stories{" "}
                  <ArrowRight
                    size={16}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesGrid;
